<template>
  <div class="pagination">
    <button :disabled="pageNo == 1" @click="$emit('getPageNo', pageNo - 1)">
      上一页
    </button>
    <button
      v-if="startNumAndEndNum.start > 1"
      @click="$emit('getPageNo', 1)"
      :class="{ active: pageNo == 1 }"
    >
      1
    </button>
    <button v-if="startNumAndEndNum.start > 2">···</button>

    <!-- 连续的页码 -->
    <button
      v-for="(page, index) in startNumAndEndNum.end"
      :key="index"
      v-if="page >= startNumAndEndNum.start"
      @click="$emit('getPageNo', page)"
      :class="{ active: pageNo == page }"
    >
      {{ page }}
    </button>

    <button v-if="startNumAndEndNum.end < totalPage - 1">···</button>
    <button
      v-if="startNumAndEndNum.end < totalPage"
      @click="$emit('getPageNo', totalPage)"
      :class="{ active: pageNo == totalPage }"
    >
      {{ totalPage }}
    </button>
    <button
      @click="$emit('getPageNo', pageNo + 1)"
      :disabled="pageNo == totalPage"
    >
      下一页
    </button>

    <button style="margin-left: 30px">共 {{ total }} 条</button>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: ["pageNo", "pageSize", "total", "continues"],

  computed: {
    // *计算总共多少页,也就是最后一页（需要向上取整Math.ceil）
    totalPage() {
      return Math.ceil(this.total / this.pageSize);
    },

    // *计算出连续页码的起始数字与结束的数字【连续的页码数字：至少是5】
    startNumAndEndNum() {
      const { continues, pageNo, totalPage } = this; // 解构了
      // 先定义两个变量存储起始数字与结束数字
      let start = 0,
        end = 0;
      // *连续页码数字是5【至少5页】，如果出现不正常现象【不够5页，即总页数 < 连续页码5】
      if (continues > totalPage) {
        start = 1;
        end = totalPage;
      } else {
        // 正常现象【连续的页码5，但是你的总页数一定是大于5的】 parseInt()返回一个十进制的整数【一个数字的参数可同Math.floor】
        start = pageNo - parseInt(continues / 2);
        end = pageNo + parseInt(continues / 2);
        // 把出现不正常的现象【start数字出现0|负数，continues=5，pageNo=1、2的时候】
        if (start < 1) {
          start = 1;
          end = continues;
        }
        // 把出现不正常的现象【end数字大于总页码，continues=5，totalPage=30，pageNo=29、30的时候】
        if (end > totalPage) {
          start = totalPage - continues + 1;
          end = totalPage;
        }
      }
      return { start, end };
    },
  },
};
</script>

<style lang="less" scoped>
.pagination {
  text-align: center;
  button {
    margin: 0 5px;
    background-color: #f4f4f5;
    color: #606266;
    outline: none;
    border-radius: 2px;
    padding: 0 4px;
    vertical-align: top;
    display: inline-block;
    font-size: 13px;
    min-width: 35.5px;
    height: 28px;
    line-height: 28px;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
    border: 0;

    // 选择带有disabled属性的所有元素
    &[disabled] {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    &.active {
      cursor: not-allowed;
      background-color: #409eff;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Pagination.vue?7be9d9bc